import { render, staticRenderFns } from "./UploadAsideLine.vue?vue&type=template&id=4dab90bc&scoped=true"
import script from "./UploadAsideLine.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadAsideLine.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadAsideLine.vue?vue&type=style&index=0&id=4dab90bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab90bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dab90bc')) {
      api.createRecord('4dab90bc', component.options)
    } else {
      api.reload('4dab90bc', component.options)
    }
    module.hot.accept("./UploadAsideLine.vue?vue&type=template&id=4dab90bc&scoped=true", function () {
      api.rerender('4dab90bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/personalCenter/views/components/UploadAsideLine.vue"
export default component.exports